(function() {
	'use strict';

	angular.module('requestApp').controller('FileTemplateControllerAF',
			FileTemplateControllerAF);

	FileTemplateControllerAF.$inject = [ '$timeout', 'FileTemplateServiceAF',
			'$state', '$http', '$scope', '$uibModal', 'GLOBAL_URL', 'Upload',
			'authExpiredInterceptor', '$base64', '$window', '$stateParams',
			'CommonService', 'RELATIONSHIP_TYPE','RIGHTS_EDUCATION', 'PAPER_TYPE' ];

	function FileTemplateControllerAF($timeout, FileTemplateServiceAF, $state,
			$http, $scope, $uibModal, GLOBAL_URL, Upload,
			authExpiredInterceptor, $base64, $window, $stateParams,
			CommonService, RELATIONSHIP_TYPE, RIGHTS_EDUCATION, PAPER_TYPE) {
		var vm = this;
		var self = $scope;
		vm.isResultError=false;
		vm.isResultSuccess=false;
		vm.param = {};
		vm.flagAgeValidate = false;
		vm.relationShipTypes = RELATIONSHIP_TYPE;
		vm.rightsEducations = RIGHTS_EDUCATION;
		vm.paperTypes = PAPER_TYPE;
		vm.filesByPaperType = [];
		vm.archiveDataIds = [];
		// Get type of organization
		self.typeOfOrganizations = CommonService.query({
			masterurl : 'organization-type'
		});
		/*
		 * Loại hình tổ chức/ doanh nghiệp = “Tổ chức tài chính” / “Quỹ tín
		 * thác”, 2 op neu chon la co ====> show warning
		 */
		vm.showWarning = function(value) {
			self.clearMessage();
			if (value != 'OTHER') {
				self.addAlert('Kiểm tra lại với tư vấn viên thông tin này.',
						'warning');
			}
		};
		vm.showWarningEntity = function(value) {
			self.clearMessage();
			if (value == "1") {
				self.addAlert('Kiểm tra lại với tư vấn viên thông tin này.',
						'warning');
			}
		};
		vm.showWarningUsBenOwer = function(value) {
			self.clearMessage();
			if (value == "1") {
				self.addAlert('Kiểm tra lại với tư vấn viên thông tin này.',
						'warning');
			}
		};
		$scope.$watch('form', function(form) {
			vm.validateForm = form;
		});
		vm.firstLoad = true;
		vm.getProposalInfo = function() {
			FileTemplateServiceAF.get({
				uri : 'initPage'
			}, function(result) {
				vm.proposal = result;
				initPage1(vm, self);
				initPage2(vm, self);
				initPage4(vm, FileTemplateServiceAF, self);
				vm.proposal.receiptDate = null;
				InitPage();
				if ($stateParams.proposalNum !== undefined
						&& $stateParams.proposalNum !== null) {
					var proposalNum = $base64.decode($stateParams.proposalNum);
					if (vm.firstLoad) {
						vm.proposal.proposalNum = proposalNum;
						vm.searchByProposalNum();
					}
				}
			});
		}

		vm.occupation = [];
		vm.getOccupation = function() {
			FileTemplateServiceAF.query({
				uri : 'getOccupations'
			}, function(result) {
				vm.occupation = result;

			});
		};
		vm.listNationality = [];
		vm.getNationality = function() {
			FileTemplateServiceAF.query({
				uri : 'getNationality'
			}, function(result) {
				vm.listNationality = result;
			});
		};

		vm.getPhoneCode = function() {
			FileTemplateServiceAF.query({
				uri : 'getPhoneCode'
			}, function(result) {
				vm.listPhoneCode = result;
			});
		};

		vm.getListEducation = function() {
			FileTemplateServiceAF.query({
				uri : 'getEducationItems'
			}, function(result) {
				vm.listEducation = result;
			});
		};

		vm.province = [];
		vm.getProvince = function() {
			FileTemplateServiceAF.query({
				uri : 'getProvinceList'
			}, function(result) {
				vm.province = result;
			});
		};
		$scope.format = 'dd/MM/yyyy';

		$scope.productCode = $base64.decode($state.params.productCode);
		vm.altInputFormats = [ 'M!/d!/yyyy' ];

		vm.urlContent = "";
		vm.index = "0";
		vm.success = null;
		vm.showExcess = false;
		vm.searchByProposalNum = function() {
			vm.firstLoad = false;
			if (vm.proposal.proposalNum != undefined
					&& vm.proposal.proposalNum != null
					&& vm.proposal.proposalNum != '') {
				FileTemplateServiceAF
						.get(
								{
									uri : 'proposalNum',
									proposalNum : vm.proposal.proposalNum
								},
								function(result) {
									if (result.proposalNum === undefined
											|| result.proposalNum === null) {
										self.addAlert(
												'Số hồ sơ không tồn tại.',
												'danger');
										return;
									}
									vm.proposal = result;
									vm.attachmentLiberty=[];
									vm.attachmentLiberty.content=result.attachmentLiberty;
									vm.attachmentLiberty.name=result.attachmentLibertyName;
									vm.attachmentLiberty.type=result.attachmentLibertyType;
									vm.proposal.po.incomeRange = result.po.incomeRange != null ? result.po.incomeRange :'03';
									if(result.attachments != null) {
										for (var int = 0; int < result.attachments.length; int++) {
											var file = {};
											file.name = result.attachments[int].dataName;
											file.size = result.attachments[int].contentType;
											file.type = result.attachments[int].dataType;
											file.archiveDataId = result.attachments[int].archiveDataId;
											if(result.attachments[int].paperType != null && result.attachments[int].paperType != undefined) {
												var obj = {'file':file,'paperType':result.attachments[int].paperType,'paperTypeName':getNameDropDownList(result.attachments[int].paperType),'archiveDataId':result.attachments[int].archiveDataId};
												vm.filesByPaperType.push(obj);
											}else {
												var obj = {'file':file,'paperType':result.attachments[0].paperType,'paperTypeName':getNameDropDownList(result.attachments[0].paperType), 'archiveDataId':result.attachments[0].archiveDataId};
												vm.filesByPaperType.push(obj);
												break;
											}
											
										}
										
									}
									vm.getBenefitItems();
									// vm.attachment.name =
									// vm.proposal.dataName;
									if ($stateParams.productCode !== undefined
											&& $stateParams.productCode !== null) {
										var productCode = $base64
												.decode($stateParams.productCode);
										if (productCode != vm.proposal.contractType) {
											vm.resetProposal();
											self
													.addAlert(
															'Hệ thống chưa hỗ trợ tạo hợp đồng dự thảo cho sản phẩm này.',
															'danger');
											return;
										}
									}
									// if
									// (vm.proposal.contractType.includes("VL"))
									// {
									if (vm.proposal.contractType.indexOf("VL") !== -1) {
										vm.showExcess = true;
									}
									$scope.isDisabled = true;
									if (vm.proposal.agentCode !== null) {
										vm.searchAgent(1);
									} else {
										vm.agentName = null;
									}
									if (vm.proposal.sharedAgentCode !== null) {
										vm.searchAgent(2);
									} else {
										vm.sharedAgentName = null;
									}
									vm.defaultPage4();
									if (vm.proposal.isPoLa == '1') {
										vm.PoIsLA = true;
										/*
										 * angular.copy(vm.proposal.po.customer,
										 * vm.proposal.laList[0].customer);
										 */
									}
									if(vm.proposal.po.bankAccountCode != undefined
										&& vm.proposal.po.bankAccountCode != null
										&& vm.proposal.po.bankAccountCode != '') {
										vm.getBranchBank();
									}
									if (vm.proposal.po.addressVN.provinceCode != null) {
										vm
												.getDistrict(
														vm.proposal.po.addressVN.provinceCode,
														3);
									}
									if (vm.proposal.po.addressVN.districtCode != undefined
											&& vm.proposal.po.addressVN.districtCode !== null) {
										vm
												.getWard(
														vm.proposal.po.addressVN.districtCode,
														3);
									}
									if (vm.proposal.alternativeAddress.street !== undefined
											&& vm.proposal.alternativeAddress.street !== null
											&& vm.proposal.alternativeAddress.street !== '') {
										vm.checkAlternaitve = true;
										if (vm.proposal.alternativeAddress.provinceCode != undefined
												&& vm.proposal.alternativeAddress.provinceCode != null
												&& vm.proposal.alternativeAddress.provinceCode.length >= 2) {
											vm
													.getDistrict(
															vm.proposal.alternativeAddress.provinceCode,
															3);
										}
										if (vm.proposal.alternativeAddress.districtCode != undefined
												&& vm.proposal.alternativeAddress.districtCode != null
												&& vm.proposal.alternativeAddress.districtCode.length >= 4) {
											vm
													.getWard(
															vm.proposal.alternativeAddress.districtCode,
															3);
										}
									} else {
										vm.checkAlternaitve = false;
									}
									if (vm.proposal.po.customer.locationCode !== undefined
											&& vm.proposal.po.customer.locationCode !== null
											&& vm.proposal.po.customer.locationCode.length >= 6) {
										var locationCode = vm.proposal.po.customer.locationCode;
										if (vm.proposal.po.poType == 'C') { // to
											// chuc
											var province = locationCode
													.substring(0, 2);
											vm.provinceForeignAddressPO = province;
											vm.getDistrict(province, 1);
											var district = locationCode
													.substring(0, 4);
											vm.districtForeignAddressPO = district;
											vm.getWard(district, 1);
										} else if (vm.proposal.po.poType == 'P') { // ca
											// nhan
											var province = locationCode
													.substring(0, 2);
											vm.provinceForeignAddressPO = province;
											vm.getDistrict(province, 2);
											var district = locationCode
													.substring(0, 4);
											vm.districtForeignAddressPO = district;
											vm.getWard(district, 2);
										}
									}
									if (vm.proposal.laList[0].customer.locationCode !== undefined
											&& vm.proposal.laList[0].customer.locationCode !== null
											&& vm.proposal.laList[0].customer.locationCode.length >= 6) {
										var locationCode = vm.proposal.laList[0].customer.locationCode;
										var province = locationCode.substring(
												0, 2);
										vm.provinceMainLA = province;
										vm.getDistrict(province, 4);
										var district = locationCode.substring(
												0, 4);
										vm.districtMainLA = district;
										vm.getWard(district, 4);
									}
									if (vm.proposal.po.poType == 'C') {
										vm.relationShipPO = [ {
											code : '0000',
											name : 'Nhân viên'
										} ];
										vm.PoIsLA = false;
										vm.PoIsBHBS = false;
										// 20180626: Default Từ 4.5 triệu đến 7.5 triệu
										if(vm.proposal.po.incomeRange == null || vm.proposal.po.incomeRange == undefined || vm.proposal.po.incomeRange ==''){
											vm.proposal.po.incomeRange = '03';
										}
									} else if (vm.proposal.po.poType == 'P') {
										vm.relationShipPO = [];
										vm.loadQuanHe();
									}
									
								});
			} else {
				return;
			}
		}
//		vm.sendLiberty = function() {
//			// check validate all page
//			if (vm.validatePage2Send() || vm.validatePage4()) {
//				return false;
//			}
//			vm.setQuestion8();
//			var data = [];
//			if (vm.attachment !== undefined && vm.attachment !== null) {
//				data['file'] = vm.attachment;
//				/*
//				 * } else { data['file'] = new File([ "" ], "filename.txt");
//				 */
//			}
//			if (vm.attachmentLiberty !== undefined && vm.attachmentLiberty !== null) {
//				data['fileLiberty'] = vm.attachmentLiberty;
//				/*
//				 * } else { data['file'] = new File([ "" ], "filename.txt");
//				 */
//			}
//			data['proposal'] = new Blob([ JSON.stringify(vm.proposal) ], {
//				type : "application/json"
//			});
//			$scope.loading = true;
//			Upload.upload(
//					{
//						url : GLOBAL_URL + 'api/request/sendLiberty?access_token='
//								+ authExpiredInterceptor.getToken(),
//						data : data
//					}).then(function(result) {
//				$scope.loading = false;
//				$(window).scrollTop(0);
//				if (result.status === 200) {
//					self.addAlert('Gửi thông tin sang liberty thành công.',
//					'success');
//					vm.proposal.checkAllDisable = true;
//				}else{
//					self.addAlert('Gửi thông tin sang liberty thất bại.',
//					'error');
//				}
//			}, function(result) {
//				$scope.loading = false;
//			}, function(evt) {
//				// $scope.loading = false;
//			});
//		}
		vm.searchAgent = function(type) {

			if (type == 1) {
				var code = vm.proposal.agentCode;
				if (code == undefined || code == null || code == '') {
					vm.agentName = '';
					return;
				}
				if (code != undefined || code != '') {
					var numCode = Number(code);
					if (numCode < 10000000)
						numCode += 60000000;
					vm.proposal.agentCode = numCode.toString();
				}
				FileTemplateServiceAF.get({
					uri : 'get-agent',
					agentCode : vm.proposal.agentCode
				}, function(result) {
					vm.agentName = result.agentName;
					vm.mdrtpf1 = result.mdrtpf;
				});
			} else if (type == 2) {
				var code = vm.proposal.sharedAgentCode;
				if (code == undefined || code == null || code == '') {
					vm.sharedAgentName = '';
					return;
				}
				if (code != undefined || code != '') {
					var numCode = Number(code);
					if (numCode < 10000000)
						numCode += 60000000;
					vm.proposal.sharedAgentCode = numCode.toString();
				}
				FileTemplateServiceAF.get({
					uri : 'get-agent',
					agentCode : vm.proposal.sharedAgentCode
				}, function(result) {
					vm.sharedAgentName = result.agentName;
					vm.mdrtpf2 = result.mdrtpf;
				});
			}
		}
		vm.changeTab = function(index) {
			if (vm.proposal !== undefined) {
				var hasError = false;
				if (hasError)
					return;
				if (vm.index == 1) {
					var flag = vm.invalidTab1();
					if (flag || vm.flagAgeValidate) {
						return;
					}
				} else if (vm.index == 2) {
					if (vm.validatePage2()) {
						return false;
					}

				} else if (vm.index == 4) {
					if (vm.validatePage4() || vm.flagAgeValidate) {
						return false;
					}
				}
			}
			vm.index = index;
			if (index === 1) {
				$state.go('fileTemplate.pageOne');
			} else if (index === 2) {
				$state.go('fileTemplate.pageTwo');
			} else if (index === 4) {
				$state.go('fileTemplate.pageFour');
			} else if (index === 8) {
				$state.go('fileTemplate.pageEight');
			}else if (index === 10) {
//				var modalInstance = $uibModal.open({
//				      animation: $scope.animationsEnabled,
//				      templateUrl: GLOBAL_URL
//						+ 'partial?uri=ga/newbusinessform/filetemplate/dialogConfirm',
//				      controller: 'DialogConfirmController as confirmController',
//				      size: 'mi',
//				      resolve: {
//				      }
//				    });
//
//					 modalInstance.result.then(function (checkItem) {
//					    	if(checkItem){
					    		$state.go('fileTemplate.pageTen');
//					    	}
//					    }, function () {
//					    	 vm.changeTab(vm.indexOld)
//					    });
		}

		}

		vm.popupDOIns = false;
		vm.popupDateReceipt = false;
		vm.popupDateOfBirthPO = false;
		vm.popupDateOfBirthLA = false;
		vm.popupDateOfBirthSubLA = false;

		$scope.dateOptions = {
			maxDate : new Date(),
			minDate : new Date(1900, 1, 1)
		}
		vm.openDatePicker = function(index) {
			if (index == 1) {
				vm.popupDOIns = true;
			} else if (index == 2) {
				vm.popupDateReceipt = true;
			} else if (index == 3) {
				vm.popupDateOfBirthPO = true;
			} else if (index == 4) {
				vm.popupDateOfBirthLA = true;
			} else if (index == 5) {
				vm.popupDateOfBirthThirdLA = true;
			} else if (index == 6) {
				vm.popupDateOfBirthFourthLA = true;
			} else if (index == 7) {
				vm.ngayDuSinh06 = true;
			} else if (index == 8) {
				vm.ngayDuSinh16 = true;
			} else if (index == 9) {
				vm.popupDateOfBirthSubLA = true;
			} else if (index == 10) {
				vm.ngayDuSinh1 = true;
			} else if (index == 11) {
				vm.ngayDuSinh0 = true;
			}
		};

		vm.calculaNumberYear = function(date, dob, type) {
			if(!moment(dob).isValid()){
				return;
			}
			if (date === undefined || date === null || dob === undefined
					|| dob === null) {
				return;
			}
			if (vm.proposal.receiptDate === undefined
					|| vm.proposal.receiptDate === null
					|| vm.proposal.receiptDate === '') {
				if (type == 1) {
					vm.proposal.po.customer.dob = null;
				} else if (type == 2) {
					vm.proposal.laList[0].customer.dob = null;
				}
				return;
			}
			dob = new Date(dob).getTime();
			var dateNow = new Date(vm.proposal.receiptDate).getTime();
			if (dob > dateNow) {
				if (type == 1) {
					vm.proposal.po.customer.dob = null;
					vm.proposal.po.customer.age = null;
				} else if (type == 2) {
					vm.proposal.laList[0].customer.dob = null;
					vm.proposal.laList[0].customer.age = null;
				}
				return;
			}

			FileTemplateServiceAF.get({
				uri : 'calculateAge',
				birthMsDate : dob,
				trMsDate : vm.proposal.receiptDate
			}, function(result) {
				if (result !== null) {
					if (type == 1) {
						if (result.age > 120) {
							self.addAlert('Tuổi người mua bảo hiểm phải nhỏ hơn 120','danger');
							vm.proposal.po.customer.age =null;
							vm.proposal.po.customer.dob=null;
							vm.flagAgeValidate = true;
						}else{
							vm.proposal.po.customer.age = result.age;
							//20180626: On leave: tính tuổi của client --> nếu tuổi ≤ 16 tuổi: hệ thống điền giá trị "Độc thân" vô field <Tình trạng hôn nhân>/"Tình trạng gia đình"
							if(result.age <= 16) {
								vm.proposal.po.customer.marriedStatus = 'S'
							}
						}
					} else if (type == 2) {
						vm.proposal.laList[0].customer.age = result.age;
						if (result.age > 120) {
							self.addAlert('Tuổi Người Được Bảo Hiểm phải nhỏ hơn 120','danger');
							vm.proposal.laList[0].customer.age =null;
							vm.proposal.laList[0].customer.dob=null;
							vm.flagAgeValidate = true;
						}else{
							vm.loadQuanHe();
							//20180626: On leave: tính tuổi của client --> nếu tuổi ≤ 16 tuổi: hệ thống điền giá trị "Độc thân" vô field <Tình trạng hôn nhân>/"Tình trạng gia đình"
							if(result.age <= 16) {
								vm.proposal.laList[0].customer.marriedStatus = 'S'
							}
							vm.flagAgeValidate = false;
						}
						
					}
					/*if (type == 1) {
						vm.proposal.po.customer.age = result.age;
					} else if (type == 2) {
						vm.proposal.laList[0].customer.age = result.age;
						vm.loadQuanHe();
					}*/
				}
			}).$promise
					.then(function(result) {
						if (type == 2) {
							FileTemplateServiceAF
									.get(
											{
												uri : 'validateEntryMonth',
												birthMsDate : dob
											},
											function(result) {
												if (result !== null && vm.proposal.contractType == 'RO1') {
													if (result.age == 1) {
														self
																.addAlert(
																		'Người được bảo hiểm chưa đủ tuổi tham gia sản phẩm.',
																		'danger');
														vm.proposal.laList[0].customer.dob = null;
														vm.proposal.laList[0].customer.age = null;
													} else {
														$scope.clearMessage();
														if(result.age <= 16) {
															vm.proposal.laList[0].customer.marriedStatus = 'S'
														}
													}
												} else {
													$scope.clearMessage();
												}
											})
						}
					});
			;
		}

		var modalInstance = null;
		vm.checkIDNum = [ -1, -1 ];
		vm.checkNameAgeSexNum = [ -1, -1 ];
		vm.typeCustomer = null;

		vm.checkCMND = function(cmnd, type) {
			if (cmnd == undefined || cmnd === null || cmnd == '') {
				return;
			}
			// 0: po, 1: la
			vm.typeCustomer = type;
			vm.checkIDNum[type] = type;
			var customerType = '';
			if (vm.typeCustomer != 0) {
				customerType = 'P';
			} else if (vm.typeCustomer == 0) {
				customerType = vm.proposal.po.poType;
			}
			FileTemplateServiceAF
					.query(
							{
								uri : 'getListCustomerWithIDNum',
								idNum : cmnd,
								customerType : customerType
							},
							function(result) {
								vm.items = result;
								modalInstance = $uibModal
										.open({
											animation : true,
											templateUrl : GLOBAL_URL
													+ 'partial?uri=ga/newbusinessform/filetemplate/modalCMND',
											controller : 'CheckIDNumDialogControllerAF',
											controllerAs : 'checkCtrl',
											size : 'lg',
											resolve : {
												items : function() {
													return vm.items;
												}
											}
										});
								modalInstance.result.then(function(clientCode) {
									vm.loadCustomerInfo(clientCode);
									modalInstance = null;
								}, function() {
								});
							});
		};

		vm.loadCustomerInfo = function(clientCode) {
			var customerType = '';
			if (vm.typeCustomer != 0) {
				customerType = 'P';
			} else if (vm.typeCustomer == 0) {
				customerType = vm.proposal.po.poType;
			}
			FileTemplateServiceAF.get({
				uri : 'getCustomerInfo',
				clientCode : clientCode,
				customerType : customerType
			}, function(result) {
				if (vm.typeCustomer === 0) {
					setPOInfo(vm, result);
				} else if (vm.typeCustomer === 1) {
					setMainLAInfo(vm, result);
				}
			});

		};

		vm.getDistrict = function(provinceCode, type) {
			/*
			 * if (provinceCode == undefined || provinceCode == null) return; if
			 * (provinceCode !== undefined && provinceCode !== null)
			 */{
				if (provinceCode === undefined || provinceCode === null) {
					provinceCode = '';
				}
				FileTemplateServiceAF
						.query(
								{
									uri : 'getDistrictList',
									provinceCode : provinceCode
								},
								function(result) {
									if (result != null) {
										if (type == 1) {
											if (vm.validateForm.provinceForeignAddressPO !== undefined
													&& vm.validateForm.provinceForeignAddressPO !== null
													&& vm.validateForm.provinceForeignAddressPO.$dirty) {
												vm.districtForeignAddressPO = null;
												vm.proposal.po.customer.locationCode = null;
											}
											vm.listDistrictForeign = result
										} else if (type == 2) {
											if (vm.validateForm.provinceForeignAddressPO !== undefined
													&& vm.validateForm.provinceForeignAddressPO !== null
													&& vm.validateForm.provinceForeignAddressPO.$dirty) {
												vm.districtForeignAddressPO = null;
												vm.proposal.po.customer.locationCode = null;
											}
											vm.listDistrictForeignPersonal = result;
										} else if (type == 3) {
											if (vm.validateForm.provinceAddressPO !== undefined
													&& vm.validateForm.provinceAddressPO !== null
													&& vm.validateForm.provinceAddressPO.$dirty) {
												vm.proposal.alternativeAddress.districtCode = null;
												vm.proposal.alternativeAddress.wardCode = null;
											}
											vm.listDistrictVN = result;
										} else if (type == 4) {
											if (vm.validateForm.provinceMainLA !== undefined
													&& vm.validateForm.provinceMainLA !== null
													&& vm.validateForm.provinceMainLA.$dirty) {
												vm.districtMainLA = null;
												vm.proposal.laList[0].customer.locationCode = null;
											}

											vm.listDistrictMainLA = result;
										} else if (type == 5) {
											if (vm.validateForm.provinceCodeFAO !== undefined
													&& vm.validateForm.provinceCodeFAO !== null
													&& vm.validateForm.provinceCodeFAO.$dirty) {
												vm.districtCodeFAO = null;
												vm.proposal.po.customer.faoAddress.districtCode = null;
											}

											vm.listDistrictFAO = result;
										}
										//
										vm.listDistrictMainLA = result;
										vm.listDistrictSubLA = result;
										vm.listDistrictthirdLA = result;
										vm.listDistrictfourthLA = result;
										vm.copyProvinceLA(provinceCode);
									}
								});
			}
		};

		vm.getWard = function(districtCode, type) {
			if (districtCode == undefined || districtCode == null)
				districtCode = '';
			FileTemplateServiceAF
					.query(
							{
								uri : 'getWardList',
								districtCode : districtCode
							},
							function(result) {
								if (result != null) {
									if (type == 1) {
										if (vm.validateForm.districtForeignAddressPO !== undefined
												&& vm.validateForm.districtForeignAddressPO !== null
												&& vm.validateForm.districtForeignAddressPO.$dirty) {
											vm.proposal.po.customer.locationCode = null;
										}
										vm.listWardForeign = result;
									} else if (type == 2) {
										if (vm.validateForm.districtForeignAddressPO !== undefined
												&& vm.validateForm.districtForeignAddressPO !== null
												&& vm.validateForm.districtForeignAddressPO.$dirty) {
											vm.proposal.po.customer.locationCode = null;
										}
										vm.listWardForeignPersonal = result;
									} else if (type == 3) {
										if (vm.validateForm.districtAddressPO !== undefined
												&& vm.validateForm.districtAddressPO !== null
												&& vm.validateForm.districtAddressPO.$dirty) {
											vm.proposal.alternativeAddress.wardCode = null;
										}
										vm.listWardVN = result;
									} else if (type == 4) {
										if (vm.validateForm.districtMainLA !== undefined
												&& vm.validateForm.districtMainLA !== null
												&& vm.validateForm.districtMainLA.$dirty) {
											vm.proposal.laList[0].customer.locationCode = null;
										}
										vm.listWardMainLA = result;
									} else if (type == 5) {
										if (vm.validateForm.districtCodeFAO !== undefined
												&& vm.validateForm.districtCodeFAO !== null
												&& vm.validateForm.districtCodeFAO.$dirty) {
											vm.proposal.po.customer.faoAddress.districtCode = null;
										}
										vm.listWardFAO = result;
									}
									//
									vm.listWardMainLA = result;
									vm.listWardSubLA = result;
									vm.listWardthirdLA = result;
									vm.listWardfourthLA = result;
									vm.copyDistrictLA(districtCode);
								}
							});
		};
		vm.checkPOIsLA = function(isPOLA) {
			if (isPOLA === 1) {
				if (!vm.PoIsLA) {
					angular.copy(vm.initCustomer(),
							vm.proposal.laList[0].customer);
					vm.provinceMainLA = null;
					vm.districtMainLA = null;
					vm.proposal.laList[0].relationshipCode = '';
					vm.relationShipPO = [];
					vm.proposal.isPoLa = 0;
				} else {
					angular.copy(vm.proposal.po.customer,
							vm.proposal.laList[0].customer);
					if (vm.proposal.laList[0].customer.locationCode !== null
							&& vm.proposal.laList[0].customer.locationCode.length >= 6) {
						if($scope.productCode != null && $scope.productCode != undefined && $scope.productCode =='RO1') {
							vm.proposal.laList[0].customer.occupation = null;
						}
						var locationCode = vm.proposal.laList[0].customer.locationCode;
						var province = locationCode.substring(0, 2);
						vm.provinceMainLA = province;
						vm.getDistrict(province, 4);
						var district = locationCode.substring(0, 4);
						vm.districtMainLA = district;
						vm.getWard(district, 4);
						vm.provincesubLA = null;
						vm.districtsubLA = null;
					}
					vm.proposal.laList[0].relationshipCode = '0000';
					vm.loadQuanHe();
					vm.proposal.isPoLa = 1;
				}
			}
		}

		vm.createTemplateFile = function() {
			if (vm.index == 4) {
				if (vm.validatePage4()) {
					$(window).scrollTop(0)
					return false;
				}
			}

			if (vm.index == 1) {
				var flag = vm.invalidTab1();
				if (flag) {
					$(window).scrollTop(0);
					return;
				}
			}

			var data = [];

			data['proposal'] = new Blob([ JSON.stringify(vm.proposal) ], {
				type : "application/json"
			});
			$scope.loading = true;
			//mutiple images
			if (vm.filesByPaperType !== undefined && vm.filesByPaperType !== null && vm.filesByPaperType.length > 0) {
				var files = [];
				var paperTypeCodes = [];
				for (var int = 0; int < vm.filesByPaperType.length; int++) {
					if(vm.filesByPaperType[int].archiveDataId != null && vm.filesByPaperType[int].archiveDataId != undefined && vm.filesByPaperType[int].archiveDataId == 0) {
						files.push(vm.filesByPaperType[int].file);
						paperTypeCodes.push({'paperType':vm.filesByPaperType[int].paperType,'paperTypeName':vm.filesByPaperType[int].paperTypeName});
					}
				}
				data['file'] = files;
				data['filesByPaperType'] = new Blob([ JSON.stringify(paperTypeCodes) ], {
					type : "application/json"
				});
				Upload
						.upload(
								{
									url : GLOBAL_URL
											+ 'api/request/saveInsuranceApplication?access_token='
											+ authExpiredInterceptor.getToken(),
									data : data,arrayKey:''
								}).then(function(result) {
							$(window).scrollTop(0);
							// vm.proposal.dataName = vm.attachment.name;
							if(result && result.data != null && result.data.insuranceApplicationId != null && result.data.insuranceApplicationId != undefined) {
								FileTemplateServiceAF.query({
									uri : 'get-list-archive-data',
									insuranceApplicationId:result.data.insuranceApplicationId
								}, function(respon) {
									if(respon) {
										vm.filesByPaperType = [];
										for (var int = 0; int < respon.length; int++) {
											var file = {};
											file.name = respon[int].dataName;
											file.size = respon[int].contentType;
											file.type = respon[int].dataType;
											file.archiveDataId = respon[int].archiveDataId;
											if(respon[int].paperType != null && respon[int].paperType != undefined) {
												var obj = {'file':file,'paperType':respon[int].paperType,'paperTypeName':getNameDropDownList(respon[int].paperType),'archiveDataId':respon[int].archiveDataId};
												vm.filesByPaperType.push(obj);
											}else {
												var obj = {'file':file,'paperType':respon[int].paperType,'paperTypeName':getNameDropDownList(respon[int].paperType), 'archiveDataId':respon[int].archiveDataId};
												vm.filesByPaperType.push(obj);
												break;
											}
											
										}
									}
									$scope.loading = false;
								}, function() {
									$scope.loading = false;
								});
							}
						}, function(result) {
							$scope.loading = false;
						}, function(evt) {
							$scope.loading = false;
						});
			} else {
				FileTemplateServiceAF.post({
					uri : 'saveInsurance'
				}, vm.proposal, function() {
					$(window).scrollTop(0);
					$scope.loading = false;
				}, function() {
					$scope.loading = false;
				});
			}

		}

		vm.sendnb = function() {
			// check validate all page
			if (vm.validatePage2Send() || vm.validatePage4()) {
				return false;
			}
			var data = [];
			//mutiple images
			if (vm.filesByPaperType !== undefined && vm.filesByPaperType !== null) {
				var files = [];
				var paperTypeCodes = [];
				for (var int = 0; int < vm.filesByPaperType.length; int++) {
					if(vm.filesByPaperType[int].archiveDataId != null && vm.filesByPaperType[int].archiveDataId != undefined && vm.filesByPaperType[int].archiveDataId == 0) {
						files.push(vm.filesByPaperType[int].file);
						paperTypeCodes.push({'paperType':vm.filesByPaperType[int].paperType,'paperTypeName':vm.filesByPaperType[int].paperTypeName});
					}
				}
				data['file'] = files;
				data['filesByPaperType'] = new Blob([ JSON.stringify(paperTypeCodes) ], {
					type : "application/json"
				});
			}
			if (vm.attachmentLiberty !== undefined && vm.attachmentLiberty !== null) {
				data['fileLiberty'] = vm.attachmentLiberty;
				/*
				 * } else { data['file'] = new File([ "" ], "filename.txt");
				 */
			}
			data['proposal'] = new Blob([ JSON.stringify(vm.proposal) ], {
				type : "application/json"
			});
			$scope.loading = true;
			Upload.upload(
					{
						url : GLOBAL_URL + 'api/request/sendnb?access_token='
								+ authExpiredInterceptor.getToken(),
						data : data
					}).then(function(resp) {
				$(window).scrollTop(0)
				vm.proposal.checkAllDisable = true;
				if (resp.data.messages[0].type != 'success') {
					vm.isResultError=true;
				}
				$scope.loading = false;
			}, function(resp) {
				$scope.loading = false;
			}, function(evt) {
				 $scope.loading = false;
			});
		}

		vm.relationShipPO = [];
		vm.loadQuanHe = function() {
			if (vm.proposal.po.poType == 'C')
				return;
			if (vm.proposal.po.customer.dob != undefined
					&& vm.proposal.po.customer.dob != null
					&& vm.proposal.po.customer.dob != '') {
				var dateNow = new Date();
				if (vm.proposal.po.customer.dob > dateNow.getTime()) {
					return;
				}
				if (vm.proposal.laList[0].customer.dob === undefined
						|| vm.proposal.laList[0].customer.dob === null
						|| vm.proposal.laList[0].customer.dob == '')
					return;
				var birth = new Date(vm.proposal.laList[0].customer.dob);
				FileTemplateServiceAF.query({
					uri : 'getRelationShip',
					birth : birth,
					gender : vm.proposal.po.customer.gender
				}, function(result) {
					vm.relationShipPO = result;
				})
			}
		}

		vm.changeRelationShip = function() {
			if (vm.proposal.po.poType == 'C') {
				if (vm.PoIsLA) {
					vm.PoIsLA = false;
					vm.checkPOIsLA(1);
				}
				if (vm.PoIsBHBS) {
					vm.PoIsBHBS = false;
					vm.checkPOIsLA(2);
				}
				vm.relationShipPO = [ {
					code : '0000',
					name : 'Nhân viên'
				} ];
				vm.checkIDNum[0] = -1;
				if (vm.provinceForeignAddressPO !== undefined
						&& vm.provinceForeignAddressPO !== null
						&& vm.provinceForeignAddressPO !== '') {
					vm.getDistrict(vm.provinceForeignAddressPO, 1);
				}
				if (vm.districtForeignAddressPO !== undefined
						&& vm.districtForeignAddressPO !== null
						&& vm.districtForeignAddressPO !== '') {
					vm.getWard(vm.districtForeignAddressPO, 1);
				}
			} else if (vm.proposal.po.poType == 'P') {
				vm.relationShipPO = [];
				vm.loadQuanHe();
				vm.checkIDNum[0] = -1;
				if (vm.provinceForeignAddressPO !== undefined
						&& vm.provinceForeignAddressPO !== null
						&& vm.provinceForeignAddressPO !== '') {
					vm.getDistrict(vm.provinceForeignAddressPO, 2);
				}
				if (vm.districtForeignAddressPO !== undefined
						&& vm.districtForeignAddressPO !== null
						&& vm.districtForeignAddressPO !== '') {
					vm.getWard(vm.districtForeignAddressPO, 2);
				}
			}
		}

		vm.searchQuotation = function() {
			if (vm.proposal.quotationID === null
					|| vm.proposal.quotationID == '') {
				self.addAlert('Chưa nhập minh họa số.', 'danger');
				return;
			}
			if (vm.proposal.agentCode === null || vm.proposal.agentCode == '') {
				self.addAlert('Chưa nhập số tư vấn viên.', 'danger');
				return;
			}
			vm.PoIsLA = false;
			vm.PoIsBHBS = false;
			FileTemplateServiceAF.get({
				uri : 'searchQuotation',
				quotationID : vm.proposal.quotationID,
				agentCode : vm.proposal.agentCode,
				proposalNum : vm.proposal.proposalNum,
				sharedAgentCode : vm.proposal.sharedAgentCode
			}, function(result) {
				if (result.po != undefined && result.po != null) {
					vm.proposal = result;
					if (vm.proposal.agentCode !== null) {
						vm.searchAgent(1);
					} else {
						vm.agentName = null;
					}
					if (vm.proposal.sharedAgentCode !== null) {
						vm.searchAgent(2);
					} else {
						vm.sharedAgentName = null;
					}
					// if (vm.proposal.contractType.includes("VL")) {
					if (vm.proposal.contractType.indexOf("VL") !== -1) {
						vm.showExcess = true;
					}
					if (vm.proposal.isPoLa == '2') {
						vm.PoIsBHBS = true;
						angular.copy(vm.proposal.po.customer,
								vm.proposal.laList[1].customer);
					} else if (vm.proposal.isPoLa == '1') {
						vm.PoIsLA = true;
						angular.copy(vm.proposal.po.customer,
								vm.proposal.laList[0].customer);
					}
					vm.proposal.po.incomeRange = result.po.incomeRange != null ? result.po.incomeRange :'03';
					vm.calculaNumberYear(vm.proposal.receiptDate,
							vm.proposal.po.customer.dob, 1);
					vm.calculaNumberYear(1, vm.proposal.laList[0].customer.dob,
							2);
					initPage1(vm, self);
					initPage2(vm, self);
					initPage4(vm, FileTemplateServiceAF, self);
					// vm.proposal.receiptDate = null;
				} else {
					self.addAlert('Minh họa số không hỗ trợ sản phẩm này.',
							'danger');
				}
			});
		}

		vm.checkAlternativeAddress = function() {
			if (vm.proposal.alternativeAddress.provinceCode != undefined
					&& vm.proposal.alternativeAddress.provinceCode != null
					&& vm.proposal.alternativeAddress.provinceCode.length >= 2) {
				vm.getDistrict(vm.proposal.alternativeAddress.provinceCode, 3);
			}
			vm.proposal.alternativeAddress.districtCode = vm.districtForeignAddressPO;
			if (vm.proposal.alternativeAddress.districtCode != undefined
					&& vm.proposal.alternativeAddress.districtCode != null
					&& vm.proposal.alternativeAddress.districtCode.length >= 4) {
				vm.getWard(vm.proposal.alternativeAddress.districtCode, 3);
			}
			/*
			 * if (vm.checkAlternaitve) { vm.proposal.alternativeAddress.street =
			 * vm.proposal.po.customer.street;
			 * vm.proposal.alternativeAddress.countryCode =
			 * vm.proposal.po.customer.residentCountryCode;
			 * vm.proposal.alternativeAddress.provinceCode =
			 * vm.provinceForeignAddressPO;
			 * 
			 * vm.proposal.alternativeAddress.wardCode =
			 * vm.proposal.po.customer.locationCode; } else {
			 * vm.proposal.alternativeAddress.street = "";
			 * vm.proposal.alternativeAddress.countryCode = "";
			 * vm.proposal.alternativeAddress.provinceCode = "";
			 * vm.proposal.alternativeAddress.districtCode = "";
			 * vm.proposal.alternativeAddress.wardCode = ""; }
			 */
		}

		vm.changeWard = function() {
			/*
			 * if (vm.PoIsLA) { if (vm.proposal.laList[0].customer.locationCode
			 * !== null && vm.proposal.laList[0].customer.locationCode.length >=
			 * 6) { var locationCode =
			 * vm.proposal.laList[0].customer.locationCode; var province =
			 * locationCode.substring(0, 2); vm.provinceMainLA = province;
			 * vm.getDistrict(province, 4); var district =
			 * locationCode.substring(0, 4); vm.districtMainLA = district;
			 * vm.getWard(district, 4); } if
			 * (vm.proposal.po.customer.locationCode !== null &&
			 * vm.proposal.po.customer.locationCode.length >= 6) { var
			 * locationCode = vm.proposal.po.customer.locationCode; var province =
			 * locationCode.substring(0, 2); vm.provinceForeignAddressPO =
			 * province; vm.getDistrict(province, 2); var district =
			 * locationCode.substring(0, 4); vm.districtForeignAddressPO =
			 * district; vm.getWard(district, 2); } }
			 */
		}

		vm.validateAllRequired = function(flag) {
			var error = vm.validateForm.$error.required;
			if (error != undefined) {
				for (var i = 0; i < error.length; i++) {
					if (error[i].$invalid) {
						error[i].$setValidity("required", false);
						error[i].$setTouched();
						error[i].$setDirty();
						flag = true;
					}
				}
			}
			var error = vm.validateForm.$error.minlength;
			if (error != undefined) {
				for (var i = 0; i < error.length; i++) {
					if (error[i].$invalid) {
						error[i].$setValidity("minlength", false);
						error[i].$setTouched();
						error[i].$setDirty();
						flag = true;
					}
				}
			}
			var error = vm.validateForm.$error.maxlength;
			if (error != undefined) {
				for (var i = 0; i < error.length; i++) {
					if (error[i].$invalid) {
						error[i].$setValidity("maxlength", false);
						error[i].$setTouched();
						error[i].$setDirty();
						flag = true;
					}
				}
			}
			var error = vm.validateForm.$error.pattern;
			if (error != undefined) {
				for (var i = 0; i < error.length; i++) {
					if (error[i].$invalid) {
						error[i].$setValidity("pattern", false);
						error[i].$setTouched();
						error[i].$setDirty();
						flag = true;
					}
				}
			}
			return flag;
		}

		vm.resetProposal = function() {
			/*
			 * vm.getProposalInfo(); vm.agentName = null; vm.sharedAgentName =
			 * null; vm.validateForm.$setPristine();
			 * vm.validateForm.$setUntouched(); vm.changeTab(1); vm.PoIsLA =
			 * false; vm.PoIsBHBS = false; $scope.isDisabled = false;
			 */
			$window.location.reload();
		}

		vm.initCustomer = function() {
			var cus = {
				evidenceSource : "ID",
				residentCountryCode : "VN",
				nationality : "VN",
				otherNationality : "",
				birthCountryCode : "VN",
				educationCode : "",
				occupation : "OPIT",
				provinceCode : "",
				districtCode : "",
				homePhoneCode : "84",
				mobileCode : "84",
				bizPhoneCode : "84",
				firstName : null,
				lastName : null,
				preferedName : null,
				gender : null,
				dob : null,
				age : null,
				marriedStatus : null,
				ethnic : null,
				street : null,
				locationCode : null,
				idNum : null,
				mobilePhone : null,
				bizPhone : null,
				homePhone : null,
				occupationCode : null,
				occupationClass : null,
				occupationDescription : null,
				magnumCode : null,
				position : null,
				email : null,
				birthPlace : null,
				incomeDetail : null,
				companyName : null,
				companyAddress : null,
				salutation : "QUÝ"
			}
			return cus;
		}

		vm.removeFileAttach = function(file, errFiles) {
			if (file != undefined && file != null) {
				vm.proposal.dataName = file.name;
			}
		}

		vm.benefitItems = [];
		vm.getBenefitItems = function() {
			FileTemplateServiceAF.query({
				uri : 'getBenefitItems',
				productCode : vm.proposal.contractType
			}, function(result) {
				if (result != null) {
					vm.benefitItems = result;
				}
			});
		};

		vm.getAttachmentInfo = function() {
			FileTemplateServiceAF.get({
				uri : 'getAttachmentInfo',
				proposalInfo : vm.proposal.proposalNum
			}, function(result) {
				if (result !== null) {
					vm.download(result);
				}
			});
		}

		vm.download = function(attach) {
			// danh cho ie
			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for
				// IE
				// browser
				if (attach.content != undefined) {
					var byteCharacters = atob(attach.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : attach.dataType
					});
					window.navigator.msSaveBlob(blob, attach.dataName);
				} else {
					var blob = new Blob([ attach ], {
						type : attach.dataType
					});
					window.navigator.msSaveBlob(blob, attach.dataName);
				}
			} else {
				// truong hop file da luu duoi database
				if (attach.content != undefined) {
					var byteCharacters = atob(attach.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : attach.dataType
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = attach.dataName;
					aTag.click();
				} else {
					// truong hop file luu tam tren man hinh
					var blob = new Blob([ vm.attachment ], {
						type : vm.attachment.type
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = vm.attachment.name;
					aTag.click();
				}
			}
		}

		vm.downloadLiberty = function(attach) {
			// danh cho ie
			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for
				// IE
				// browser
				if (attach.content != undefined) {
					var byteCharacters = atob(attach.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : attach.dataType
					});
					window.navigator.msSaveBlob(blob, attach.dataName);
				} else {
					var blob = new Blob([ attach ], {
						type : attach.dataType
					});
					window.navigator.msSaveBlob(blob, attach.dataName);
				}
			} else {
				// truong hop file da luu duoi database
				if (attach.content != undefined) {
					var byteCharacters = atob(attach.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : attach.type
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = attach.name;
					aTag.click();
				} else {
					// truong hop file luu tam tren man hinh
					var blob = new Blob([ vm.attachmentLiberty ], {
						type : vm.attachmentLiberty.type
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = vm.attachmentLiberty.name;
					aTag.click();
				}
			}
		}

		vm.checkTaxCode = function(taxCode) {
			if (taxCode == undefined || taxCode === null || taxCode == '') {
				return;
			}
			vm.typeCustomer = 0;
			var customerType = 'C';
			FileTemplateServiceAF
					.query(
							{
								uri : 'getListCustomerWithTaxCode',
								idNum : taxCode,
								customerType : customerType
							},
							function(result) {
								vm.items = result;
								modalInstance = $uibModal
										.open({
											animation : true,
											templateUrl : GLOBAL_URL
													+ 'partial?uri=ga/newbusinessform/filetemplate/modalCMND',
											controller : 'CheckIDNumDialogControllerAF',
											controllerAs : 'checkCtrl',
											size : 'lg',
											resolve : {
												items : function() {
													return vm.items;
												}
											}
										});
								modalInstance.result.then(function(clientCode) {
									vm.loadCustomerInfo(clientCode);
									modalInstance = null;
								}, function() {
								});
							});
		};
		vm.searchLongDesc = function(type) {
			if (type == 1) {
				FileTemplateServiceAF.get({
					uri : 'search-long-desc',
					descItem : vm.proposal.descItem
				}, function(result) {
					vm.proposal.longDesc = result.name;
				});
			} else if (type == 2) {
				FileTemplateServiceAF.get({
					uri : 'search-long-desc',
					descItem : vm.proposal.sharedDescItem
				}, function(result) {
					vm.proposal.sharedLongDesc = result.name;
				});
			}
		}
		vm.checkAgeNum = function(lgivname, lsurname, cltdob, cltsex,
				customerType) {
			if (lgivname == undefined || lgivname === null || lgivname == ''
					|| lsurname == undefined || lsurname === null
					|| lsurname == '' || cltdob == undefined || cltdob === null
					|| cltdob == '' || cltsex == undefined || cltsex === null
					|| cltsex == '') {
				return;
			}
			// 0: po, 1: la
			vm.typeCustomer = customerType;
			vm.checkNameAgeSexNum[customerType] = customerType;
			var customerType = '';
			if (vm.typeCustomer != 0) {
				customerType = 'P';
			} else if (vm.typeCustomer == 0) {
				customerType = vm.proposal.po.poType;
			}
			var date = new Date(cltdob);
			var cltdobDate = date.getTime();
			vm.param.uri = 'get-lis-cus-by-multiple-key';
			vm.param.clientFirstName = lsurname;
			vm.param.clientBirthDate = cltdobDate;
			vm.param.clientLastName = lgivname;
			vm.param.clientGender = cltsex;
			vm.param.clientType = customerType;
			FileTemplateServiceAF.query(vm.param).$promise
					.then(function(result) {
						vm.items = result;
						modalInstance = $uibModal
								.open({
									animation : true,
									templateUrl : GLOBAL_URL
											+ 'partial?uri=ga/newbusinessform/filetemplate/modalCMND',
									controller : 'CheckIDNumDialogControllerAF',
									controllerAs : 'checkCtrl',
									size : 'lg',
									resolve : {
										items : function() {
											return vm.items;
										}
									}
								});
						modalInstance.result.then(function(clientCode) {
							vm.loadCustomerInfo(clientCode);
							modalInstance = null;
						}, function() {
						});
					});
		};
		
		 vm.checkPrefixOccupationRD = function(code,index) {
				if (code != undefined && code != '') {
					var str = code.substring(0, 1);
					if(str == 'R' || str == 'D' || str == '4') {
						if(index == 4)
							vm.proposal.po.customer.occupationClass = '4';
						else
							vm.proposal.laList[index].customer.occupationClass = '4';
					}else if(str == '1') {
						if(index == 4)
							vm.proposal.po.customer.occupationClass = '1';
						else
							vm.proposal.laList[index].customer.occupationClass = '1';
					}else if(str == '2') {
						if(index == 4)
							vm.proposal.po.customer.occupationClass = '2';
						else
							vm.proposal.laList[index].customer.occupationClass = '2';
					}else if(str == '3') {
						if(index == 4)
							vm.proposal.po.customer.occupationClass = '3';
						else
							vm.proposal.laList[index].customer.occupationClass = '3';
					}
				}
			}
		
		// get info from page 1 to page 4  when choose value
		vm.getInfoFromRelationShipType = function(code, index) {
			 if (code != null && code != undefined && code != '') {
				 var lastName,firstName,gender,idNum,dob,street,nationality = null;
				 switch (code) {
					case 'BMBH':
						lastName = vm.proposal.po.customer.lastName;
						firstName = vm.proposal.po.customer.firstName;
						gender = vm.proposal.po.customer.gender;
						idNum = vm.proposal.po.customer.idNum;
						dob = vm.proposal.po.customer.dob;
						street = vm.proposal.po.customer.street;
						nationality = vm.proposal.po.customer.nationality;
						break;
					case 'NDBHC':
						lastName = vm.proposal.laList[0].customer.lastName;
						firstName = vm.proposal.laList[0].customer.firstName;
						gender = vm.proposal.laList[0].customer.gender;
						idNum = vm.proposal.laList[0].customer.idNum;
						dob = vm.proposal.laList[0].customer.dob;
						street = vm.proposal.laList[0].customer.street;
						nationality = vm.proposal.laList[0].customer.nationality;
						break;
					case 'NDBHBS1':
						lastName = vm.proposal.laList[1].customer.lastName;
						firstName = vm.proposal.laList[1].customer.firstName;
						gender = vm.proposal.laList[1].customer.gender;
						idNum = vm.proposal.laList[1].customer.idNum;
						dob = vm.proposal.laList[1].customer.dob;
						street = vm.proposal.laList[1].customer.street;
						nationality = vm.proposal.laList[1].customer.nationality;				
						break;
					case 'NDBHBS2':
						lastName = vm.proposal.laList[2].customer.lastName;
						firstName = vm.proposal.laList[2].customer.firstName;
						gender = vm.proposal.laList[2].customer.gender;
						idNum = vm.proposal.laList[2].customer.idNum;
						dob = vm.proposal.laList[2].customer.dob;
						street = vm.proposal.laList[2].customer.street;
						nationality = vm.proposal.laList[2].customer.nationality;
						break;
					case 'NDBHBS3':
						lastName = vm.proposal.laList[3].customer.lastName;
						firstName = vm.proposal.laList[3].customer.firstName;
						gender = vm.proposal.laList[3].customer.gender;
						idNum = vm.proposal.laList[3].customer.idNum;
						dob = vm.proposal.laList[3].customer.dob;
						street = vm.proposal.laList[3].customer.street;
						nationality = vm.proposal.laList[3].customer.nationality;
						break;
					case 'KHAC':
						gender = 'M';
						nationality = 'VN';
						break;
					default:
						break;
					}
				 	vm.proposal.benList[index].customer.lastName = lastName;
					vm.proposal.benList[index].customer.firstName = firstName;
					vm.proposal.benList[index].customer.gender = gender;
					vm.proposal.benList[index].customer.idNum = idNum;
					vm.proposal.benList[index].customer.dob = dob;
					vm.proposal.benList[index].customer.street = street;
					vm.proposal.benList[index].customer.nationality = nationality ;
					vm.benCMNDPage4(index);
			 }
		 }
		 // upload multiple files
		 vm.chooseUploadFiles = function (file,paperType) {
		        if (file) {
		        	if(!vm.proposal.paperType) {
						self.addAlert( 'Vui lòng chọn loại giấy tờ trước khi đính kèm file.', 'danger');
						return;
					}
		        	var obj = {'file':file,'paperType':paperType, 'paperTypeName': getNameDropDownList(paperType), 'archiveDataId': 0}
		        	vm.filesByPaperType.push(obj);
		        	vm.file = null;
		        	vm.proposal.paperType = null;
		        }
		    };
	    $scope.$watch('vm.file', function () {
	    	if(vm.proposal)
	    		vm.chooseUploadFiles(vm.file,vm.proposal.paperType);
	    });
		    
		function getNameDropDownList(paperTypeCode) {
		      for (var i = 0; i <vm.paperTypes.length; i++) {
		    	    if (vm.paperTypes[i].code == paperTypeCode) {
		    	        return vm.paperTypes[i].name;
		    	    }
		      }
		      return null;
		}
		vm.removeFile = function(index) {
			if(vm.filesByPaperType.length > 0 && vm.filesByPaperType[index].file.archiveDataId != undefined && vm.filesByPaperType[index].file.archiveDataId != 0){
				FileTemplateServiceAF.get({
					uri : 'remove-archive-data',
					archiveDataId:vm.filesByPaperType[index].file.archiveDataId
				}, function() {
					vm.filesByPaperType.splice(index,1);
					$scope.loading = false;
				}, function() {
					$scope.loading = false;
				});
			}else {
				vm.filesByPaperType.splice(index,1);
			}
		}
		
		vm.copyStreet = function(value) {
			if (value != null && value != undefined && value != '') {
				vm.proposal.laList[0].customer.street = value;
				vm.proposal.laList[1].customer.street = value;
				vm.proposal.laList[2].customer.street = value;
				vm.proposal.laList[3].customer.street = value;
			}else {
				vm.proposal.laList[0].customer.street = null;
				vm.proposal.laList[1].customer.street = null;
				vm.proposal.laList[2].customer.street = null;
				vm.proposal.laList[3].customer.street = null;
			}
		}
		
		vm.copyResidentCountryCode = function(value) {
			if (value != null && value != undefined && value != '') {
				vm.proposal.laList[0].customer.residentCountryCode = value;
				vm.proposal.laList[1].customer.residentCountryCode = value;
				vm.proposal.laList[2].customer.residentCountryCode = value;
				vm.proposal.laList[3].customer.residentCountryCode = value;
			}else {
				vm.proposal.laList[0].customer.residentCountryCode = null;
				vm.proposal.laList[1].customer.residentCountryCode = null;
				vm.proposal.laList[2].customer.residentCountryCode = null;
				vm.proposal.laList[3].customer.residentCountryCode = null;
			}
		}
		
		vm.copyProvinceLA = function(value) {
			if(vm.proposal.checkAllDisable != null && vm.proposal.checkAllDisable != undefined && !vm.proposal.checkAllDisable) {
				if (value != null && value != undefined && value != '') {
					vm.provinceMainLA = value;
					vm.provincesubLA = value;
					vm.provincethirdLA = value;
					vm.provincefourthLA = value;
				}else {
					vm.provinceMainLA = null;
					vm.provincesubLA = null;
					vm.provincethirdLA = null;
					vm.provincefourthLA = null;
					//
					vm.districtMainLA = null;
					vm.districtsubLA = null;
					vm.districtthirdLA = null;
					vm.districtfourthLA = null;
					//
					vm.proposal.laList[0].customer.locationCode = null;
					vm.proposal.laList[1].customer.locationCode = null;
					vm.proposal.laList[2].customer.locationCode = null;
					vm.proposal.laList[3].customer.locationCode = null;
				}
			}
		}
		
		vm.copyDistrictLA = function(value) {
			if(vm.proposal.checkAllDisable != null && vm.proposal.checkAllDisable != undefined && !vm.proposal.checkAllDisable) {
				if (value != null && value != undefined && value != '') {
					vm.districtMainLA = value;
					vm.districtsubLA = value;
					vm.districtthirdLA = value;
					vm.districtfourthLA = value;
				}else {
					vm.districtMainLA = null;
					vm.districtsubLA = null;
					vm.districtthirdLA = null;
					vm.districtfourthLA = null;
					//
					vm.proposal.laList[0].customer.locationCode = null;
					vm.proposal.laList[1].customer.locationCode = null;
					vm.proposal.laList[2].customer.locationCode = null;
					vm.proposal.laList[3].customer.locationCode = null;
				}
			}
		}
		
		vm.copyWardLA = function(value) {
			if(vm.proposal.checkAllDisable != null && vm.proposal.checkAllDisable != undefined && !vm.proposal.checkAllDisable) {
				if (value != null && value != undefined && value != '') {
					vm.proposal.laList[0].customer.locationCode = value;
					vm.proposal.laList[1].customer.locationCode = value;
					vm.proposal.laList[2].customer.locationCode = value;
					vm.proposal.laList[3].customer.locationCode = value;
				}else {
					vm.proposal.laList[0].customer.locationCode = null;
					vm.proposal.laList[1].customer.locationCode = null;
					vm.proposal.laList[2].customer.locationCode = null;
					vm.proposal.laList[3].customer.locationCode = null;
				}
			}
		}

		vm.banks = [];
		vm.getBanks = function() {
			CommonService.query({
				masterurl : 'get-all-bank-las'
			}, function(result) {
				vm.banks = result;
			});
		};

		vm.branchs = [];
		vm.getBranchBank = function() {
			if (vm.proposal.po.bankAccountCode != undefined
					&& vm.proposal.po.bankAccountCode != null
					&& vm.proposal.po.bankAccountCode != '') {
				CommonService.query({
					masterurl : 'get-all-branch-las',
					bankCode : vm.proposal.po.bankAccountCode
				}, function(result) {
					vm.branchs = result;
				});
			}
		};
		vm.getBankAccountName = function(item) {
			if (item != undefined && item != null && item != '') {
				vm.proposal.po.bankAccountName = item;
			}
		};
		vm.getbranchAccountName = function(item) {
			if (item != undefined && item != null && item != '') {
				vm.proposal.po.branchAccountName = item;
			}
		};
	}
})();
